import { supabase } from '@/supabase'
import axios from 'axios'

export const service_api_service = axios.create({
  baseURL: import.meta.env.VITE_SERVICE_URL,
})

export const get_auth_header = async () => {
  const { data: { session } } = await supabase.auth.getSession()
  // No session (e.g. a visitor who hasn't started the guest funnel yet) gets no
  // header - the API answers 401 instead of the client throwing a TypeError.
  if (!session?.access_token) {
    return {}
  }
  return {
    Authorization: `Bearer ${ session.access_token }`
  }
}
